import React, { ChangeEvent, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import ImageIcon from '@mui/icons-material/Image';
import { Button, TextField, TextFieldProps } from '@mui/material';

import { Container, Error, TextFieldContainer } from './styles';

interface Props extends Omit<TextFieldProps, 'onChange'> {
  icon?: React.ReactNode;
  onImageChange?: (base64: string | null) => void;
  defaultValue: string | undefined;
}

const InputImage: React.FC<Props> = ({ onImageChange, defaultValue, ...rest }: Props) => {
  const [fileName, setFileName] = useState<string | null>(null);

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const validExtensions = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!validExtensions.includes(file.type)) {
        toast.error(
          'Tipo de arquivo não suportado. Por favor, carregue uma imagem no formato PNG, JPG ou JPEG.',
        );
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        toast.error('O arquivo não pode ser maior que 2MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result as string;
        setFileName(file.name);
        if (onImageChange) {
          onImageChange(base64);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const onUpdateFile = () => {
    if (defaultValue && !fileName) {
      setFileName(defaultValue.split('/')[1]);

      if (onImageChange) {
        onImageChange(defaultValue);
      }
    }
  };

  useEffect(() => {
    onUpdateFile();
  }, []);

  return (
    <Container>
      <input
        accept=".png,.jpg,.jpeg"
        style={{ display: 'none' }}
        id="contained-button-file"
        type="file"
        onChange={handleImageChange}
      />
      <TextFieldContainer>
        <label htmlFor="contained-button-file">
          <Button
            fullWidth
            variant="outlined"
            color={!rest.error ? 'primary' : 'error'}
            component="span"
            startIcon={<ImageIcon />}
          >
            {fileName ?? rest.label}
          </Button>
        </label>

        <TextField {...rest} style={{ display: 'none' }} />

        <Error>{rest.error}</Error>
      </TextFieldContainer>
    </Container>
  );
};

export default InputImage;
